module.exports = __webpack_public_path__ + "img/catH.7d058cde.svg";